/**
 * Configuración principal del formulario Form Master v2
 * Contiene todas las configuraciones necesarias para el funcionamiento del sistema
 */

export const FORM_CONFIG = {
  // Configuración de búsqueda global en Form Master
  search: {
    // Excluir por tipo base de pregunta (e.g., 'calculate', 'note')
    // Por defecto se excluyen 'calculate' y 'note' de los resultados
    excludeSearchByType: ['calculate', 'note'],
    // Excluir por name exacto de la pregunta (identificador único)
    excludeSearchByName: [],
    // Excluir por coincidencia en label (parcial, case-insensitive)
    excludeSearchByLabel: []
  },
  // Nota de bloqueo para campos no actualizables (config_actualizable = 0/false)
  readonlyNote: {
    enabled: true,
    text: 'Este campo está bloqueado para su edición por el administrador',
    // Nota de bloqueo para preguntas sin config_tabla/config_columna: el valor nunca se guarda
    textSinDestino: 'Este campo no se guarda: no tiene una tabla/columna configurada en el sistema (config_tabla/config_columna vacíos)'
  },
  // Políticas de visibilidad de preguntas
  visibilityPolicies: {
    // Ocultar preguntas cuando config_actualizable sea 0/false (bloqueadas por admin)
    hideNotUpdatable: {
      enabled: false
    }
  },
  // Validaciones por tipo de pregunta
  typeValidations: {
    // Aplicar validación por defecto para enteros no negativos
    // Solo se aplica si la pregunta no tiene constraint definida
    integerNonNegativeDefault: true
  },
  // Configuración de validaciones por tipo (constraints ODK)
  constraintValidations: {
    // Validaciones de fechas (e.g., .<= today())
    dates: true,
    // Validaciones por expresiones regulares (regex)
    regex: true,
    // Validaciones de selección (selected para select_multiple/select_one)
    selected: true,
    // Comparaciones generales (==, !=, <, >, <=, >=)
    comparisons: true,
    // Operadores lógicos (and / or / not)
    logical: true
  },
  // Configuración de procesamiento de preguntas
  questionProcessing: {
    // Habilitar procesamiento automático
    enabled: true,
    
    // Mostrar todas las preguntas por defecto
    showAllByDefault: true,
    
    // Configuración de estadísticas
    statistics: {
      enabled: true,
      trackVisibility: true,
      trackChanges: true
    }
  },
  
  // Configuración de menús y navegación
  navigation: {
    // Habilitar navegación por grupos
    enableGroupNavigation: true,
    
    // Mostrar estadísticas en menús
    showStatistics: true,
    
    // Configuración de breadcrumbs
    breadcrumbs: {
      enabled: true,
      showIcons: true,
      maxItems: 5
    }
  },
  
  // Configuración de formularios dinámicos
  dynamicForms: {
    // Habilitar generación dinámica
    enabled: true,
    
    // Validación automática
    autoValidation: true,
    
    // Guardado automático
    autoSave: false,
    
    // Configuración de campos
    fields: {
      // Mostrar ayuda contextual
      showHelp: true,
      
      // Validación en tiempo real
      realTimeValidation: true,
      
      // Configuración de archivos
      files: {
        maxSize: 10 * 1024 * 1024, // 10MB
        allowedTypes: ['image/*', 'audio/*', 'video/*', 'application/pdf'],
        showPreviews: true
      }
    }
  },
  
  // Configuración de desarrollo y debug
  development: {
    // Mostrar información de desarrollo
    showDevInfo: false,
    
    // Logs detallados
    verboseLogs: false,
    
    // Simulación de datos
    mockData: false
  }
};

// Configuración por defecto para exportar
export default FORM_CONFIG;